module.exports = __webpack_public_path__ + "img/banner3_3_en.efe2370c.png";